export default "__VITE_ASSET__Dtabb8Bh__"